/**
 Validates org numbers from United Kingdom, e.g. XXXXXXX
 */
export const validateUnitedKingdomOrgNumber = (number: string) => {
  const unitedKingdomOrgNumberRegex = /^([01]\d{7}|[A-Z]{2}\d{6})$/g;

  return unitedKingdomOrgNumberRegex.test(number);
};
